import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Home/HomePage.css'; // já contém variáveis e classes globais

const Header = () => {
  // ---------------- STATE ----------------
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const openLoginModal = () => setShowLoginModal(true);
  const closeLoginModal = () => setShowLoginModal(false);

  // Slideshow (mantém o que já tinhas)
  const images = ['/imagens/1.jpg', '/imagens/2.jpg'];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 15000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <header className="header">
      <nav className="navbar">
        <div className="logo">
          <img src="/imagens/logo.png" alt="Meicor Logo" />
        </div>

        {/* Botão Hamburguer (mobile) */}
        <button className="hamburger" onClick={toggleMenu} aria-label="Abrir menu">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Links de navegação + Botão de Login */}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li><a href="#about" onClick={() => setMenuOpen(false)}>Sobre</a></li>
          <li><a href="#vision-mission" onClick={() => setMenuOpen(false)}>Visão &amp; Missão</a></li>
          <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contato</a></li>
          <li><a href="#location" onClick={() => setMenuOpen(false)}>Localização</a></li>
          <li><Link to="/politica-privacidade" onClick={() => setMenuOpen(false)}>Política</Link></li>
          {/* Botão de Login: usa a classe .btn do HomePage.css */}
          <li>
            <button
              className="btn login-btn"
              onClick={openLoginModal}
              style={{ padding: '0.6rem 1.5rem', fontSize: '0.9rem' }}
            >
              Login
            </button>
          </li>
        </ul>
      </nav>

      {/* HERO COM SLIDESHOW DE IMAGENS */}
      <div className="hero">
        <img
          src={images[currentIndex]}
          alt="Slide ilustrativo"
          className="video-background"
        />
        <div className="hero-content">
          <h1>Bem-vindo à Meicor</h1>
          <p>Fabricamos cordões com excelência e inovação.</p>
          <a href="#contact" className="btn">Fale Conosco</a>
        </div>
      </div>

      {/* ================= Modal de Login ================= */}
      {showLoginModal && (
        <div className="modal-overlay" onClick={closeLoginModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeLoginModal} aria-label="Fechar">
              &times;
            </button>
            <h2>Entrar na conta</h2>
            <form className="login-form" onSubmit={(e) => {
              e.preventDefault();
              // aqui iriam as chamadas à tua API de login (por exemplo, via fetch para /api/admin/login)
              // depois de submeter, fecha a modal se for bem-sucedido:
              // closeLoginModal();
            }}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="teu@email.com"
                required
              />

              <label htmlFor="password">Senha</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="••••••••"
                required
              />

              <button type="submit" className="btn login-submit-btn">
                Entrar
              </button>
            </form>
          </div>
        </div>
      )}
      {/* ============= Fim da Modal ============= */}
    </header>
  );
};

export { Header };
